var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgMiddleFace = function SvgMiddleFace(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 18",
    stroke: "currentColor",
    role: "img",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M10.37 13.189s-3.695-1.098-3.88 1.138m3.03 1.423c0-.135.095-.83-.314-1.098-.385-.254-.906-.175-1.551-.175h-.617c-.16 0-.37-.085-.547-.15M11.627 1.5 9.32 5.542c-.64 1.121-1.256 2.117-2.281 2.89-.543.41-1.612 1.184-2.067 1.907-.466.74-.726 1.718-.104 2.695.235.37.55.69.923.938.218.145.454.264.7.355m7.76-1.764a2.1 2.1 0 0 0-.582-1.452m-.583 3.354c.699-.38 1.165-1.09 1.165-1.902"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMiddleFace);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;